export interface BreedTrustpilotEntry {
    /** Trustpilot API tag for filtering reviews */
    tag: string;
    /** Display name for the headline: "{displayName} ❤️ Spot" */
    displayName: string;
    /** Key used to resolve the breed image path */
    imageKey: string;
    /**
     * Terms to bold when they appear in review text, matched case-insensitively with word boundaries.
     * MUST be ordered longest-first so regex alternation prefers specific multi-word matches
     * (e.g. "Labrador Retriever" wins over "Labrador" which wins over "Lab").
     * Omit for tags where reviewers use generic vocabulary (e.g. "cat", "mix") to avoid highlight spam.
     */
    boldTerms?: string[];
}

const GOLDEN_BOLD_TERMS = ["Golden Retrievers", "Golden Retriever", "Goldens", "Golden"];
const LABRADOR_BOLD_TERMS = ["Labrador Retrievers", "Labrador Retriever", "Labradors", "Labrador", "Labs", "Lab"];
const FRENCHIE_BOLD_TERMS = ["French Bulldogs", "French Bulldog", "Frenchies", "Frenchie", "Frenchy"];

export const BREED_TRUSTPILOT_CONFIG: Record<string, BreedTrustpilotEntry> = {
    // Dogs - Golden Retriever
    "Golden Retriever": { tag: "golden-retriever", displayName: "Golden Retriever Parents", imageKey: "golden", boldTerms: GOLDEN_BOLD_TERMS },
    "Golden Retriever Mix": { tag: "golden-retriever", displayName: "Golden Retriever Parents", imageKey: "golden", boldTerms: GOLDEN_BOLD_TERMS },

    // Dogs - Labrador Retriever
    "Labrador Retriever": { tag: "labrador-retriever", displayName: "Labrador Parents", imageKey: "labrador", boldTerms: LABRADOR_BOLD_TERMS },
    "Labrador Retriever Mix": { tag: "labrador-retriever", displayName: "Labrador Parents", imageKey: "labrador", boldTerms: LABRADOR_BOLD_TERMS },

    // Dogs - French Bulldog
    "French Bulldog": { tag: "frenchie", displayName: "Frenchie Parents", imageKey: "frenchie", boldTerms: FRENCHIE_BOLD_TERMS },
    "French Bulldog Mix": { tag: "frenchie", displayName: "Frenchie Parents", imageKey: "frenchie", boldTerms: FRENCHIE_BOLD_TERMS },

    // Dogs - Mixed breeds
    "Small Mix (up to 10 pounds)": { tag: "mix", displayName: "Small Mix Parents", imageKey: "small-mix" },
    "Small Mix (11-25 pounds)": { tag: "mix", displayName: "Small Mix Parents", imageKey: "small-mix" },
    "Medium Mix (26-50 pounds)": { tag: "mix", displayName: "Medium Mix Parents", imageKey: "medium-mix" },
    "Large Mix (51-100 pounds)": { tag: "mix", displayName: "Large Mix Parents", imageKey: "large-mix" },

    // Cats
    "Domestic Shorthair": { tag: "cat", displayName: "Domestic Shorthair Parents", imageKey: "domestic-shorthair" },
    "Domestic Mediumhair": { tag: "cat", displayName: "Domestic Mediumhair Parents", imageKey: "domestic-mediumhair" },
    "Domestic Longhair": { tag: "cat", displayName: "Domestic Longhair Parents", imageKey: "domestic-longhair" },
    "American Shorthair": { tag: "cat", displayName: "American Shorthair Parents", imageKey: "american-shorthair" },
    "Mixed Cat": { tag: "cat", displayName: "Cat Parents", imageKey: "domestic-longhair" }
};

export function getBreedImagePath(imageKey: string): string {
    return `/images/breeds/${imageKey}.png`;
}
